/**
 * Caps automatic page reloads triggered by media starvation (camera producer sending no RTP), per browser tab.
 * Without a cap a network that blocks UDP and has no TURN relay reloads the exam every ~30 s forever.
 * If sessionStorage is unavailable the guard refuses (no reload) rather than risking an unbounded loop.
 */
const KEY = 'media_starvation_reloads';

function getStorage() {
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
}

export function allowStarvationReload({ storage = getStorage(), now = Date.now(), max = 2, windowMs = 10 * 60 * 1000 } = {}) {
  if (!storage) return false;
  try {
    const recent = (JSON.parse(storage.getItem(KEY) || '[]') || [])
      .filter((t) => typeof t === 'number' && now - t >= 0 && now - t < windowMs);
    if (recent.length >= max) {
      storage.setItem(KEY, JSON.stringify(recent));
      return false;
    }
    recent.push(now);
    storage.setItem(KEY, JSON.stringify(recent));
    return true;
  } catch (_) {
    return false;
  }
}

export function resetStarvationReloads({ storage = getStorage() } = {}) {
  try {
    storage?.removeItem(KEY);
  } catch (_) { /* ignore */ }
}
